var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-description"},[_c('div',{staticClass:"course-description-text"},[_c(_setup.HTMLRenderer,{staticClass:"h5",attrs:{"html":_vm.description || "","link-target":"_blank"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }